<template>
  <div>
    <div class="block">
      <div class="title-container">
        <h3 class="system-text">Factuurgegevens</h3>
        <button class="white-pill-s right-btn" @click="$emit('goTo')">
          Bewerken
        </button>
      </div>
      <customer-blocked-message v-if="order.invoiceAddress.blocked" />
      <p
        class="error-text pointer"
        v-else-if="
          !order.invoiceAddress.company &&
          !order.invoiceAddress.customerNumber &&
          !hideErrors
        "
      >
        <span @click="$emit('goTo')"
          >Factuuradres is niet compleet, klik hier.</span
        >
      </p>

      <div
        v-else-if="
          order.invoiceAddress.newCustomer && !order.invoiceAddress.company
        "
      >
        <p>
          <label>Klantnummer:</label> {{ order.invoiceAddress.customerNumber }}
        </p>
      </div>
      <div v-else-if="order.invoiceAddress.newCustomer">
        <p>{{ order.invoiceAddress.company }}</p>

        <p v-if="order.invoiceAddress.name">
          T.a.v. {{ order.invoiceAddress.name }}
        </p>
        <p>
          {{ order.invoiceAddress.street }} {{ order.invoiceAddress.number }}
          {{ order.invoiceAddress.addition }}
        </p>
        <p>
          {{ order.invoiceAddress.zipCode }} {{ order.invoiceAddress.city }}
        </p>
      </div>
      <div v-else>
        <p>
          <label>Klantnummer:</label> {{ order.invoiceAddress.customerNumber }}
        </p>
        <p><label>Bedrijfsnaam:</label> {{ order.invoiceAddress.company }}</p>
      </div>
    </div>
    <div class="block" v-if="!order.invoiceAddress.blocked">
      <div>
        <p
          v-if="!order.project.name && !projectRequired"
          class="system-text placeholder"
        >
          Geen project opgegeven.
        </p>

        <p
          v-else-if="!project && projectRequired && !hideErrors"
          class="error-text pointer"
          @click="$emit('goTo')"
        >
          {{ custom.project.label ? custom.project.label : 'Project' }}
          ontbreekt nog, klik hier.
        </p>

        <p v-else>
          <label
            class="system-text label-text proj"
            :class="{ warning: !validProject }"
            >{{ custom.project.label ? custom.project.label : 'Project' }}
          </label>
          <span class="project-name" :class="{ warning: !validProject }">{{
            order.project.name
          }}</span>
        </p>
        <p v-if="custom.reference.hide"></p>
        <p
          v-else-if="!reference && !custom.reference.required"
          class="system-text placeholder"
        >
          Geen
          {{
            custom.reference.label ? custom.reference.label : 'orderreferentie'
          }}
          opgegeven.
        </p>

        <p
          v-else-if="
            !order.reference && custom.reference.required && !hideErrors
          "
          class="error-text pointer"
          @click="$emit('goTo')"
        >
          {{
            custom.reference.label ? custom.reference.label : 'Orderreferentie'
          }}
          ontbreekt nog, klik hier.
        </p>
        <p v-else>
          <label :class="{ warning: !validReference }">{{
            custom.reference.label ? custom.reference.label : 'Orderreferentie'
          }}</label>

          <span :class="{ warning: !validReference }">{{
            order.reference
          }}</span>
        </p>
        <p v-if="order.quotationNo">
          <label>Offertenummer:</label> {{ order.quotationNo }}
        </p>
        <template v-if="custom.externalId?.show">
          <p
            v-if="!externalId && !custom.externalId.required"
            class="system-text placeholder"
          >
            Geen
            {{
              custom.externalId.label ? custom.externalId.label : 'externe ID'
            }}
            opgegeven.
          </p>

          <p
            v-else-if="!externalId && custom.externalId.required && !hideErrors"
            class="error-text pointer"
            @click="$emit('goTo')"
          >
            {{
              custom.externalId.label ? custom.externalId.label : 'Externe ID'
            }}
            ontbreekt nog, klik hier.
          </p>
          <p v-else>
            <label :class="{ warning: !validExternalId }">{{
              custom.externalId.label ? custom.externalId.label : 'Externe ID'
            }}</label>

            <span :class="{ warning: !validExternalId }">{{
              order.externalId
            }}</span>
          </p>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import CustomerBlockedMessage from '@/components/CustomerBlockedMessage.vue'

export default {
  props: {
    order: Object,
    orderType: String,
    price: {
      default: '',
      required: false
    },
    quote: {
      default: false
    },
    hideErrors: {
      default: false
    }
  },
  //props: ['order', 'orderType', {'price'}],
  data() {
    return {
      validProject: true,
      validReference: true,
      validExternalId: true
    }
  },
  components: {
    CustomerBlockedMessage
  },
  methods: {},
  computed: {
    custom() {
      return this.rootStore.theme.customFields
    },
    projectRequired() {
      if (this.quote) {
        return false
      }
      return this.custom.project.required || this.rootStore.user.projectRequired
        ? true
        : false
    },
    project() {
      const name = this.order.project.name?.trim() || ''
      const prefix = this.custom.project.prefix || ''
      if (prefix && name.startsWith(prefix)) return name.slice(prefix.length)
      return name
    },
    reference() {
      if (this.order.reference) {
        return this.order.reference.trim() || ''
      } else {
        return ''
      }
    },
    externalId() {
      const value = this.order.externalId?.trim() || ''
      const prefix = this.custom.externalId?.prefix || ''
      if (prefix && value.startsWith(prefix)) return value.slice(prefix.length)
      return value
    },
    values() {
      let values = []
      if (this.custom.project.fields.length > 1) {
        const parts = this.project.split(this.custom.project.hyphen || '-')
        parts.forEach((item, key) => {
          values[key] = item
        })
      } else {
        values[0] = this.project
      }
      return values
    }
  },
  created() {
    let valid = []
    let blocked = false
    for (let i = 0; i < this.custom.project.fields.length; i++) {
      const format = this.custom.project.fields[i].format
        ? new RegExp(this.custom.project.fields[i].format)
        : ''

      if (
        this.projectRequired &&
        this.custom.project.fields.length === 1 &&
        this.values[0].length == 0
      ) {
        valid[0] = false
      } else if (format) {
        if (!this.values[i]) {
          this.values[i] = ''
        }

        valid[i] = format.test(this.values[i])
      } else {
        valid[i] = true
      }
    }
    this.validProject = !valid.includes(false)

    const refFormat = this.custom.reference.format
      ? new RegExp(this.custom.reference.format)
      : ''

    if (this.custom.reference.required && this.order.reference.length == 0) {
      this.validReference = false
    } else if (refFormat) {
      this.validReference = refFormat.test(this.order.reference)
    } else {
      this.validReference = true
    }

    if (this.custom.externalId?.show) {
      const externalIdFormat = this.custom.externalId.format
        ? new RegExp(this.custom.externalId.format)
        : ''

      if (this.custom.externalId.required && this.externalId.length == 0) {
        this.validExternalId = false
      } else if (externalIdFormat) {
        this.validExternalId = externalIdFormat.test(this.externalId)
      } else {
        this.validExternalId = true
      }
    } else {
      this.validExternalId = true
    }

    if (this.custom.hideInvoiceOptions) {
      this.$emit('removeError', 'invoiceError')
    } else if (
      this.order.invoiceAddress.blocked ||
      !this.validProject ||
      !this.validReference ||
      !this.validExternalId ||
      (!this.order.invoiceAddress.company &&
        !this.order.invoiceAddress.customerNumber)
    ) {
      this.$emit('addError', 'invoiceError')
    } else {
      this.$emit('removeError', 'invoiceError')
    }
  }
}
</script>

<style lang="scss" scoped>
.project-name {
  display: inline-block;
}

.warning {
  color: red;
}
</style>
